<script setup lang="ts">
/**
 * Final Dividends — Minutes of EGM (Sole Individual Member, s.184G written resolution).
 *   원본: Minutes of EGM – Final Dividends (Sole Individual Member).
 *   서명 없음 — 멤버 확인란(밑줄 + [[Member_Name]]).
 */
import CddVarField from '../cdd/CddVarField.vue';
import './agmDoc.css';
</script>

<template>
  <div class="agm-doc">
    <div class="doc-head">
      <div><b><CddVarField field-key="company_name" label="Company Name" /></b></div>
      <div>Company Registration No. <CddVarField field-key="company_registration_no" label="Reg No" /></div>
      <div>(Incorporated in the Republic of Singapore)</div>
      <div>(the &ldquo;Company&rdquo;)</div>
    </div>

    <div class="doc-title">MINUTES OF EXTRAORDINARY GENERAL MEETING</div>
    <p class="doc-p">
      I, the undersigned, being the Sole Member of the Company beneficially entitled to the whole of the issued shares of the Company
      do hereby pass the following ordinary resolutions pursuant to Section 184G of the Companies Act 1967 and agree that the said
      resolution shall, for all purposes be as valid and effective as if the same had been passed at the Extraordinary General Meeting
      of the Company duly convened and held on <CddVarField field-key="meeting_date" label="Meeting Date" />.
    </p>

    <div class="sec-title" style="text-align:center">FINAL DIVIDEND</div>
    <p class="doc-p">
      IT WAS NOTED THAT the Company has sufficient profits for the declaration of a final dividend of
      <CddVarField field-key="dividend_amount" label="Dividend Amount" /> to its member.
    </p>
    <p class="doc-p">
      IT WAS RESOLVED THAT a final one-tier tax exempt dividend of <CddVarField field-key="dividend_amount" label="Dividend Amount" />
      in respect of the financial year ended <CddVarField field-key="financial_year_end" label="Financial Year End" />
      and is hereby approved for payment out of the profits of the Company to the member whose names appear on the Register of Members as follows:-
    </p>

    <table class="cdd-tbl">
      <thead><tr><th>Shareholder</th><th>Amount</th></tr></thead>
      <tbody>
        <tr><td><CddVarField field-key="member_name" label="Member Name" /></td><td><CddVarField field-key="dividend_amount" label="Dividend Amount" /></td></tr>
      </tbody>
    </table>

    <p class="doc-p" style="text-align:right">Confirmed by,</p>
    <div class="sign-line"></div>
    <p class="doc-p"><CddVarField field-key="member_name" label="Member Name" /><br />Member</p>
  </div>
</template>
